
export { default as Image } from "./icons/image.js"
export { default as MessageSquare } from "./icons/message-square.js"
export { default as Music } from "./icons/music.js"
export { default as Video } from "./icons/video.js"
export { default as Zap } from "./icons/zap.js"